import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'sy-dismiss',
  styleUrls: ['scss/index.scss', 'scss/_tokens.scss'],
  shadow: true,
})
export class Dismiss {
  /**
   * Sets dismiss button state to disabled.
   */
  @Prop({ reflect: true }) disabled = false;

  /**
   * Sets dismiss size to large.
   */
  @Prop({ reflect: true }) large = false;

  render() {
    return (
      <Host>
        <sy-button class="button-dismiss" content="icon-only" icon="close" disabled={this.disabled}></sy-button>
      </Host>
    );
  }
}
